import React, { Component } from 'react';
import {toast } from 'react-toastify';
import { Link } from 'react-router-dom';
import cookie from 'react-cookies';
import {ValidateState} from '../../../functions'; 
import {API_URL} from '../../../constants';
import {updateValueInJson, validateAccesoGeneral, getRoles} from '../../../functions';
import axios from 'axios';
import $ from 'jquery';

let itemChecked2 = [];
export default class EditarPerfil extends Component {

    constructor(props) {
        super(props); 

        this.state = { 
            key: 0,
            categoriaLongitud:0,
            resource: {
                sRolNombre: "",
                sRolDescripcion: "",
                nRolActivo: 1,
                nTipSistema: 4650,
                activo: true
            },
            Validacion: {
                sRolNombre: {
                    Error: false,                    
                },
                sRolDescripcion: {
                    Error: false,                    
                }
            },
            hasError:false,    
            hasErrorProceso:false,        
            added: false,
            security: cookie.load('user'),
            roles: [],
            permisosAsignar:[],
            permisosActuales:[],
            permisoRol:[],
            permisos:[],
            itemChecked2:[],
            agrupador:"",
            menuGeneral:[]
        }
        
        this.handleInputChange = this.handleInputChange.bind(this);

    }

    onCheck = (id, event) => {
        const target = event.target;
        itemChecked2[event.target.name] = !event.target.checked?false:true;

        let permisosAsignar = this.state.permisosAsignar;

        if(target.type === 'checkbox'){
            if(event.target.checked){
                permisosAsignar.push(id)
            }else{
                let indice = permisosAsignar.indexOf(id);

                if ( indice !== -1 ) {
                    permisosAsignar.splice( indice, 1 );
                }
            }
        }

        setTimeout(() => {
            this.setState({
                itemChecked2, 
                permisosAsignar: permisosAsignar
            });
        },100)
    }

    componentDidMount(){
        if($('#containerPanel').is("*")){
            $('#containerPanel').hide();
        }

        let locationState = this.props.location.state;
        let pathNameList = "/perfiles";

        var roles = getRoles(this.state.security);
        var rol = roles.length > 0 ? roles[0].nRolCodigo : "";

        validateAccesoGeneral(locationState, pathNameList, rol); 

        this.loadOpcionesPermiso();
    }

    componentWillMount(){
        var key = this.props.match.params.id;
        const url = `${API_URL}RolUX/SeleccionarPerfil/${key}`;

        axios.get(url).then(response => response.data)
        .then((data) => {

            if(data.result){
                this.loadPermisosAsignados(key);
            }
            
            this.setState({ resource: data.result, response: data, error: data.Error });           

        }).catch(error => {
            toast.error("¡Error al inicializar!");
        });
    }

    loadPermisosAsignados = (rolId = 0) => {

        const url = `${API_URL}RolUX/ObtenerPermisosPorRol/${rolId}`;
        axios.get(url).then(response => response.data)
        .then((data) => {

            let permisos = data.result;
            var permisosAsignar = [];
            let permisosActuales = [];

            if(permisos.length > 0){

                permisos.forEach(permiso => {
                    permisosAsignar.push(permiso.nOpcCodigo);
                    permisosActuales.push(permiso.nOpcCodigo);
                    itemChecked2["check_" + permiso.nOpcCodigo] = true;
                });

            }
            setTimeout(() => { 
                this.setState({ permisosAsignar:permisosAsignar, permisosActuales:permisosActuales, permisoRol: permisos, itemChecked2 });
            }, 100); 
                       

        })
        .catch(error => {
            toast.error("¡Error al inicializar!");
        });
    }
    
    handleClickCancel(e) {

        if(e != undefined){
            e.preventDefault();
        }

        const {history: {push}} = this.props;    
        push('/perfiles');
     }

    callFunctionButton = (event) => {

        let newState = this.state;
        newState.hasError = false;

        if (newState.resource.sRolNombre == '') {              
            newState.Validacion.sRolNombre = {Error: true};
            newState.hasError = true;
        }

        if(newState.hasError){
            this.setState(newState);
            return;
        }
        
        const url = `${API_URL}RolUX/`;
        var dataForm = this.state.resource;
        dataForm = updateValueInJson(dataForm,'nUsuCodModificacion', this.state.security.nUsuCodigo);

        const formData = JSON.stringify(dataForm);

        axios.put(
        url, 
        JSON.stringify(formData),
        { headers: {
        'Content-Type': 'application/json; charset=UTF-8' ,
        'Accept': 'application/json'
        }
        }
        ).then(
        (data)=> {             
            
            if (data.data.isSucess)
            {
                let stateResponse = this.state;

                stateResponse.added = true;

                this.setState(stateResponse);

                let perfil = data.data.result;

                /* VALIDACION DE PERMISOS */
                let permisosOriginales = this.state.permisosActuales;
                let permisosModificados = this.state.permisosAsignar;                
                
                let rolId = this.state.resource.nRolCodigo;

                let permisosEliminar = permisosOriginales.filter(x => !permisosModificados.includes(x));
                let permisosCrear = permisosModificados.filter(x => !permisosOriginales.includes(x));

                /* FIN VALIDACION DE PERMISOS */

                if(permisosCrear.length > 0){
                    this.registrarPermisos(perfil, permisosCrear);
                }

                if(permisosEliminar.length > 0){
                    this.eliminarPermisos(rolId, permisosEliminar);
                }

                setTimeout(() => { 
                    this.handleClickCancel();
                }, 1000);  

                setTimeout(() => { 
                    this.setState({added:false});
                }, 5000); 
            
            } else 
            {
                this.setState({hasErrorProceso:true});

                setTimeout(() => { 
                    this.setState({hasErrorProceso:false});
                }, 3000); 
            }
        }
        ).catch((error)=> {
        toast.error('Error no controlado.');
        this.setState({loading:false});
        });        
    }

    registrarPermisos = (perfil = null, permisosCrear = []) => {

        let rolId = this.state.resource.nRolCodigo;

        if(perfil != null){

            let dataForm = {
                "nOpcCodigo": 0,
                "nRolCodigo": rolId,
                "nVer": 1,
                "nEditar": 1,
                "activo": true,
                "usuarioCrea": perfil.nUsuCodCreacion,
                "usuarioModifica": 0,
                "fechaCrea": perfil.dRolFecCreacion,
                "fechaModifica": perfil.dRolFecModificacion,
                "messageError": "",
                "codeError": ""
            }

            const url = `${API_URL}RolUX/AsignarPermiso`;

            permisosCrear.forEach(permisoId => {

                dataForm.nOpcCodigo = permisoId;
                let formData = JSON.stringify(dataForm);

                axios.post(
                url, 
                JSON.stringify(formData),
                { headers: {
                            'Content-Type': 'application/json; charset=UTF-8' ,
                            'Accept': 'application/json'
                            }
                }
                ).then(
                (data)=> {             
                    
                    if (data.data.isSucess)
                    {
                        
                        
                    
                    } else 
                    {
                        this.setState({hasErrorProceso:true});
    
                        setTimeout(() => { 
                            this.setState({hasErrorProceso:false});
                        }, 3000); 
                    }
                }
                ).catch((error)=> {
                    console.log('Error no controlado registro de permisos.');
                    this.setState({loading:false});
                }); 

            });     
        }

        return null;
    }

    eliminarPermisos = (nRolCodigo = 0, permisosEliminar = []) => {

            permisosEliminar.forEach(permisoId => {

                let url = `${API_URL}RolUX/EliminarPermisoRol/${nRolCodigo}/${permisoId}`;

                axios.delete(
                url, 
                { headers: {
                            'Content-Type': 'application/json; charset=UTF-8' ,
                            'Accept': 'application/json'
                            }
                }
                ).then(
                (data)=> {             
                    
                    if (data.data.isSucess)
                    {
                        
                        
                    
                    } else 
                    {
                        this.setState({hasErrorProceso:true});
    
                        setTimeout(() => { 
                            this.setState({hasErrorProceso:false});
                        }, 3000); 
                    }
                }
                ).catch((error)=> {
                    console.log('Error no controlado registro de permisos.');
                    this.setState({loading:false});
                }); 

            });  

        return null;
    }

    handleInputChange(event) {
        const target = event.target;
        const value = target.type === 'checkbox' ? target.checked : target.value;
        let copyResource = this.state.resource;
        copyResource[target.name] = value;

        let validaciones = this.state.Validacion;
        validaciones[target.name] = {
            Error: false,                    
        }

        this.setState({
            resource: copyResource,
            Validacion: validaciones
        });     
    }

    loadOpcionesPermiso = (page = 1) => {

        const url = `${API_URL}RolUX/ObtenerAccesos/${page}/4650`;

        axios.get(url).then(response => response.data)
        .then((data) => {
			
			$(".ipl-progress-indicator-head").css({"width": "100%"});
			setTimeout(function()
			{
				$(".ipl-progress-indicator").hide();
				$(".ipl-progress-indicator-head").css({"width": "0%"});
            }, 200);                    

            this.setState({ permisos: data.result, pagina: page });
			this.ShowPaginationFive(page-1);
        })
        .catch(error => {
        });

    }

    /* PAGINACIÓN */
    executePaginationPrev(page, e){
		if(!$(".divPaginador a.active").prev().hasClass("btnPrevPaginador")){			
			this.executePagination(parseInt($(".divPaginador a.active").prop("id"))-1, e);
		}
	}
	
	executePaginationNext(page, e){
		if(!$(".divPaginador a.active").next().hasClass("btnNextPaginador")){
			this.executePagination(parseInt($(".divPaginador a.active").prop("id"))+1, e);
		}
	}

    executePagination(page, e){

        if(e != undefined){
            e.preventDefault();
        }

        var entity = this.state.permisos.length>0?this.state.permisos[0]:null;

        for(let index=0; index < entity.totalPages+2; index++)
        {
            if($("#"+index).is("*"))
			{
				document.getElementById(index).classList.remove("active");
			}
        }
        
        if($("#"+page).is("*")){
			document.getElementById(page).classList.add("active");
		}

		$(".ipl-progress-indicator").fadeIn();
        $(".ipl-progress-indicator-head").css({"width": "90%"});
        
        this.loadOpcionesPermiso(page);
    }

    paginationTable(){
        var entity = this.state.permisos.length > 0 ? this.state.permisos[0] : null;

        const options = [];

        if (entity !== null){

            if(entity.totalPages == 1){
                return null;
            }

            options.push(<a className="btnPrevPaginador" id={0} key={0} onClick={(e) => this.executePaginationPrev(0, e)}></a>);
            
            for(let index=1; index < entity.totalPages+1; index++)
                options.push(<a className="pageItem" id={index} key={index} onClick={(e) => this.executePagination(index, e)}> {index} </a>);

            options.push(<a className="btnNextPaginador" id={entity.totalPages+1} key={entity.totalPages+1} onClick={(e) => this.executePaginationNext(entity.totalPages+1, e)}></a>);

        return (
            <div className="divPaginador" key={"pagination"} id="pagination">
                {options}
            </div>
        );
        }
    }
	
	ShowPaginationFive(pagina){
		$(".divPaginador a.active").removeClass("active");
		$(".divPaginador a:eq("+pagina+")").next().addClass("active");
		
		$(".divPaginador .pageItem").hide();
		
		let ItemPage = parseInt($(".divPaginador a.active").prop("id"));
		if(ItemPage < 4)
		{
			$(".divPaginador .pageItem").slice(0,5).show();
		}
		else if(ItemPage < 5)
		{
			$(".divPaginador .pageItem").slice(1,6).show();
		}
		else if(ItemPage < 6)
		{
			$(".divPaginador .pageItem").slice(2,7).show();
		}
		else if(ItemPage >= 6)
		{
			$(".divPaginador .pageItem.active").prev().prev().show();
			$(".divPaginador .pageItem.active").prev().show();
			$(".divPaginador .pageItem.active").show();
			$(".divPaginador .pageItem.active").next().show();
			$(".divPaginador .pageItem.active").next().next().show();
		}
		
		if(!$(".pageItem.active").next().hasClass("pageItem")){
		  if($(".pageItem.active").prev().prev().prev().hasClass("pageItem")){
			  $(".pageItem.active").prev().prev().prev().show()
		  }
		}
		if(!$(".pageItem.active").next().next().hasClass("pageItem")){
		  if($(".pageItem.active").prev().prev().prev().prev().hasClass("pageItem")){
			  $(".pageItem.active").prev().prev().prev().prev().show()
		  }
		}
    }
    /* FIN PAGINACIÓN */

    render() {
        return (
            <div class="divRowContenedor_Panel">
                <div className="divContenedorBreadcrumbs">
                    <div className="divCenterBreadcrumbs">
                        <img src="/static/images/icoBreadcrumb.png" alt />
                        <a  href="/">
                            / Panel de Configuración General
                        </a >
                        <Link to="/permisos">
                            / Usuarios
                        </Link>
                        <Link to="/perfiles">
                            / perfiles
                        </Link>
                        <span> / Editar Perfil</span>
                    </div>
                </div>
                <div className="divTitulo_Panel">
                    Editar Perfil
                </div>

                {
                    this.state.hasErrorProceso ? 
                    <div className="relative">
                        <div className="textAlertaError">
                            <div>Error, no se pudo realizar la actualización.</div>
                        </div>
                    </div> : null
                }   

                {this.state.added ? 
                    <div className="relative">
                        <div className="textAlertaOK">
                            <div>Se actualizó el registro correctamente. Se redireccionará al listado.</div>
                        </div>
                    </div>: null
                }             
                
                <div className="div_Modulos_Noticias">
                    <div className="txtFile x-1">
                        <input type="text" placeholder="Nombre de Perfil" name='sRolNombre' 
                        value={this.state.resource.sRolNombre} maxLength={255} 
                        className={this.state.Validacion.sRolNombre.Error ? "error" : ""}  
                        onChange={this.handleInputChange}/>
                    </div>
                    
                    <div className="txtFile x-1">
                        <input type="text" placeholder="Descripción" name='sRolDescripcion' 
                        value={this.state.resource.sRolDescripcion} maxLength={255} 
                        className={this.state.Validacion.sRolDescripcion.Error ? "error" : ""}  
                        onChange={this.handleInputChange}/>
                    </div>

                    <div className="txtSelect-Radio">
                        <p style={{fontFamily: 'OpenSans', fontSize: 13}}><b>Asignar permisos:</b></p>
                        <div style={{height: 250, overflowX: 'hidden', overflowY: 'scroll', border: '1px solid #DBDCDB', borderRadius: 4, boxShadow: 'inset 1px 1px 2px 0px rgb(228, 228, 228)', paddingLeft: 10, paddingTop: 10, paddingBottom: 10}}>
                            {
                                this.state.permisos.length > 0 ?
                                this.state.permisos.map((permiso) => (
                                    <div className="inputRadio" style={{width: '100%', display: 'block'}}>
                                        <label>
                                        <input 
                                            type="checkbox" 
                                            style={{WebkitAppearance: 'checkbox', marginRight: 8}} 
                                            id={"check_" + permiso.nOpcCodigo} 
                                            name={"check_" + permiso.nOpcCodigo} 
                                            checked={this.state.permisosAsignar.includes(permiso.nOpcCodigo)}  
                                            onClick={(event) => this.onCheck(permiso.nOpcCodigo, event)}
                                        />
                                            {(permiso.sAgrupador != "" ? permiso.sAgrupador + " | " : "") + permiso.sOpcNombre}
                                        </label>
                                    </div> 
                                )) : null
                            }                           
                        </div>
                        {this.paginationTable()}
                    </div>

                    <div className="divContenedorBtn_Noticias">
                        <a href="#"  className="btnActivo noneEvent"  onClick={(event) => this.callFunctionButton(event)}>GUARDAR </a>
                        <a href="#"  onClick={(event) => this.handleClickCancel(event)}>VOLVER</a>
                    </div>
                </div>
                <br />
                <br />
            </div>
        )
    }
}
